import PropTypes from 'prop-types'
import React from 'react'
import style from './style.module.scss'
import CustomLink from '@shared/components/customLink'
import { useRouter } from 'next/router'

export default function CustomTable({ table, slug, children, smallTable, noData, isChess }) {
  const router = useRouter()
  return (
        <>
            <div className={style.tableCntr} >
                <table className={`${style.table} ${smallTable && style.smallTable}`} >
                  <thead className={router.pathname === '/ipl-indian-premier-league-2025' || router.pathname === '/ipl-indian-premier-league-2025/mobile' ? style.thredBackground : style.thead}>
                        <tr className={style.tr}>
                            {table?.header?.map((ele, index) => <th className={`${style.th} ${style.tableH}`} key={index}>
                                <span className={!isChess && style.oTh}>{ele}</span></th>)}
                        </tr>
                    </thead>

                    {children || <tbody className={style.tbody}>
                        {table?.body?.map((array, index) => <tr className={style.tr} key={index}>
                            {array?.map((ele, index) => <td className={style.th} key={index}>{ele}</td>)}
                        </tr>)}

                    </tbody>}

                    {slug &&
                        <tfoot>
                            {noData &&
                                <tr className={`${style.tr} ${style.borderTop}`} >
                                    <td colSpan={table.header.length} className={`${style.fullLink} ${style.th}`}>
                                        First medal event at 27 July, 14:00 GMT+5:30
                                    </td>
                                </tr>
                            }
                            <tr className={`${style.tr} ${style.borderTop}`} >
                                <td colSpan={table.header.length} className={`${style.fullLink} ${style.th}`}>
                                    <CustomLink href={slug || ''} prefetch={false}>
                                        <a className="overflow-hidden text-nowrap d-flex flex-row-reverse"> View Full Table &gt; </a>
                                    </CustomLink>
                                </td>
                            </tr>
                        </tfoot>
                    }

                </table>
            </div>
        </>
  )
}

CustomTable.propTypes = {
  table: PropTypes.any,
  slug: PropTypes.string,
  children: PropTypes.any,
  smallTable: PropTypes.bool,
  noData: PropTypes.bool,
  isChess: PropTypes.bool
}
